export const PLATFORMS = {
  facebook: "facebook",
  google: "dv360",
  adform: "adform",
  googleAds: "googleAds",
  ttd: "ttd",
  snapchat: "snapchat",
  xandr: "xandr",
  smartclip: "smartclip",
  postalCodes: "postalCodes",
  llCoordinates: "llCoordinates"
};
